import {generateEncodedSapiLabel} from '@vio/core/src/sapiLabel/business/generateSapiLabel'
import {extractMaidFromLabel} from '@vio/core/src/sapiLabel/business/maid'

import {objectFromURLSearchParams} from './generic'

import type {Brand} from '@vio/core/src/brand/types'
import type {NextApiRequestCookies} from 'next/dist/server/api-utils'

export const getSapiLabel = (
  queryParams: URLSearchParams,
  cookies: NextApiRequestCookies,
  anonymousId: string,
  brand: Brand
) => {
  const persistedLabel = cookies['sapiLabel']
  const persistedMaid = extractMaidFromLabel(persistedLabel)

  // Never update within the same session
  // Edge case: when a user refreshes the `maid` could change in the legacy implementation because landingQueryString is reset
  const isUserSearch = queryParams.get('userSearch') === '1'
  if (persistedLabel && isUserSearch) return persistedLabel

  const landingParameters = objectFromURLSearchParams(queryParams)

  // The utility may decide to generate a new label or not
  // Use sapiCode if available, otherwise fall back to brand.code (matching client-side logic)
  const partnerId = brand.isInternal ? undefined : brand.sapiCode || brand.code

  const newLabel = generateEncodedSapiLabel({
    anonymousId,
    landingParameters,
    persistedMaid,
    persistedLabel,
    ...(partnerId ? {partnerId} : {})
  })

  return newLabel || persistedLabel
}
